module.exports = __webpack_public_path__ + "static/media/cookie_info.5a88758a.svg";